/* eslint no-console:0 */
import '../styles/application.scss';
import 'babel-polyfill'
import 'trix/dist/trix.css'

import $ from 'jquery';

window.$ = $;
window.jQuery = $;
import Rails from 'rails-ujs'
import 'jquery-ui-dist/jquery-ui.min';

require('trix')
require('@rails/actiontext')

import 'popper.js';
import 'bootstrap';

import Vue from 'vue/dist/vue.esm';
import BootstrapVue from 'bootstrap-vue';

Vue.use(BootstrapVue)
// window.Vue = Vue;

Vue.config.productionTip = false;
Vue.config.devtools = true;
Rails.start()

import axios from 'axios';
import qs from 'qs';

Vue.prototype.$axios = axios;
axios.defaults.headers.common['X-CSRF-Token'] = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
axios.defaults.headers.common['Accept'] = 'application/json';
axios.defaults.headers.common['Content-Type'] = 'application/json';
axios.defaults.headers.common['Cache-Control'] = 'no-cache, no-store, must-revalidate';
axios.defaults.paramsSerializer = (params) => {
    return qs.stringify(params, {arrayFormat: 'brackets'});
};


document.addEventListener('DOMContentLoaded', () => {
    let vm = new Vue({
        el: '#menu',
        components: {
            ClubsFinder: () => import('../components/clubs_finder'),
        },
    });
});

document.addEventListener("DOMContentLoaded", () => {
    const el = document.querySelector("#athlete-registration-form");

    if (el) {
        new Vue({
            el: "#athlete-registration-form",
            components: {
                AthleteRegistrationForm: () =>
                    import("../components/athlete-registration-form.vue"),
            },

        });
    }
});

document.addEventListener("DOMContentLoaded", () => {
    const el = document.querySelector("#relay-registration-form");

    if (el) {
        new Vue({
            el: "relay-registration-form",
            components: {
                RelayRegistrationForm: () =>
                    import("../components/relay-registration-form.vue"),
            },

        });
    }
});

document.addEventListener('DOMContentLoaded', function () {
    const cookieAgreementEl = document.getElementById('cookies-agreement');

    // Function to disable cookies agreement
    function disableCookiesAgreement() {
        localStorage.setItem('cookies_agreement', 1);
        cookieAgreementEl.classList.add('hidden');
    }

    // Check cookie agreement state on page load
    if (localStorage.getItem('cookies_agreement') != 1) {
        cookieAgreementEl.classList.remove('hidden');
    }

    // Add click listener for closing the agreement
    const disableButton = document.getElementById('disable-cookie-btn');
    if (disableButton) {
        disableButton.addEventListener('click', disableCookiesAgreement);
    }
});

document.addEventListener('DOMContentLoaded', () => {
    const toggleButton = document.querySelector('#header-hidden-link a.show-hide');

    if (toggleButton) {
        toggleButton.addEventListener('click', function (event) {
            event.preventDefault();
            const targetSelector = this.dataset.target;
            const target = document.querySelector(targetSelector);

            if (target) {
                target.classList.toggle('show'); // Add/remove 'show' class
            }
        });
    }
});

